var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _path, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcess1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 750,
    height: 500,
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Mesa_de_trabajo_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 500
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mesa_de_trabajo_1",
    "data-name": "Mesa de trabajo 1",
    clipPath: "url(#clip-Mesa_de_trabajo_1)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M94.105,384.6V429.9H86.54v4.917h7.565v30.324h141.4V437.554H225.032v-6.01h10.474v-9.015h4.655v-4.1h-5.528V384.6Z",
    fill: "#f5f5f5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M197.956,384.729v79.911h37.55V437.049H225.032v-5.505l10.474.186v-9.015l4.746.006-.091-4.659-5.528-.136V384.6Z",
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M200.632,434.171c0,.278-25.587.5-57.143.5s-57.149-.225-57.149-.5,25.582-.5,57.149-.5S200.632,433.894,200.632,434.171Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M200.632,429.569c0,.278-25.587.5-57.143.5s-57.149-.224-57.149-.5,25.582-.5,57.149-.5S200.632,429.292,200.632,429.569Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M207.972,417.183c0,.278-25.587.5-57.143.5s-57.148-.224-57.148-.5,25.581-.5,57.148-.5S207.972,416.906,207.972,417.183Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M208.678,450.935c0,.278-25.588.5-57.143.5s-57.149-.225-57.149-.5,25.582-.5,57.149-.5S208.678,450.658,208.678,450.935Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M392.08,72.907a41.921,41.921,0,0,1,10.231-4.447l2.108-10.127,17.111-.3,2.462,10.046a41.9,41.9,0,0,1,10.382,4.084l8.648-5.668,12.311,11.887-5.36,8.84a41.9,41.9,0,0,1,4.447,10.234l10.126,2.107.3,17.111L454.8,119.137a41.925,41.925,0,0,1-4.084,10.381l5.668,8.648L444.5,150.478l-8.841-5.361a41.893,41.893,0,0,1-10.233,4.446l-2.108,10.128-17.11.3-2.463-10.047a41.987,41.987,0,0,1-10.381-4.084l-8.648,5.668L372.4,139.641l5.361-8.84a41.857,41.857,0,0,1-4.447-10.233l-10.127-2.108-.3-17.11,10.046-2.463a41.952,41.952,0,0,1,4.085-10.381l-5.668-8.648,11.886-12.312,8.842,5.361ZM401.2,95.7a18.358,18.358,0,1,0,25.958-.457A18.358,18.358,0,0,0,401.2,95.7Z",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M487.062,52.806a24.49,24.49,0,0,1,5.969-2.594L494.26,44.3l9.983-.175,1.436,5.861a24.451,24.451,0,0,1,6.057,2.382l5.045-3.307L523.963,56l-3.127,5.157a24.428,24.428,0,0,1,2.594,5.971l5.908,1.229.175,9.982-5.861,1.437a24.458,24.458,0,0,1-2.382,6.056l3.306,5.046-6.934,7.182-5.157-3.127a24.433,24.433,0,0,1-5.97,2.593l-1.23,5.909-9.982.175-1.437-5.861a24.5,24.5,0,0,1-6.056-2.383l-5.045,3.307-7.183-6.935,3.128-5.157a24.463,24.463,0,0,1-2.6-5.97l-5.908-1.229-.175-9.982,5.861-1.438a24.517,24.517,0,0,1,2.383-6.056l-3.306-5.045,6.934-7.182,5.158,3.127Zm5.321,13.3a10.71,10.71,0,1,0,15.144-.266A10.711,10.711,0,0,0,492.383,66.1Z",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M636.471,206.047a32.534,32.534,0,0,1,7.946-3.454l1.637-7.865,13.289-.233,1.912,7.8a32.567,32.567,0,0,1,8.064,3.172l6.716-4.4L685.6,210.3l-4.162,6.865a32.585,32.585,0,0,1,3.453,7.949l7.864,1.636.234,13.289-7.8,1.913a32.551,32.551,0,0,1-3.171,8.062l4.4,6.717-9.231,9.562-6.866-4.163a32.583,32.583,0,0,1-7.948,3.453l-1.637,7.865-13.288.233-1.913-7.8a32.6,32.6,0,0,1-8.063-3.173l-6.716,4.4-9.562-9.232,4.163-6.866a32.6,32.6,0,0,1-3.454-7.947l-7.865-1.637-.233-13.289,7.8-1.913a32.617,32.617,0,0,1,3.172-8.063l-4.4-6.716,9.231-9.562,6.868,4.164Zm7.084,17.7a14.257,14.257,0,1,0,20.16-.355A14.257,14.257,0,0,0,643.555,223.75Z",
    fill: "#ebebeb"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M692.985,465.925c0,.144-145.978.261-326.01.261-180.094,0-326.041-.117-326.041-.261s145.947-.26,326.041-.26C547.007,465.665,692.985,465.782,692.985,465.925Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 357.421,
    height: 279.676,
    transform: "translate(44.332 35.461)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 358.759,
    height: 23.255,
    transform: "translate(44.401 35.461)",
    fill: "#263238"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 19.958,
    height: 256.421,
    transform: "translate(44.401 58.716)",
    fill: "#455a64"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 358.759,
    height: 15.412,
    transform: "translate(44.401 58.716)",
    fill: "#455a64"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M51.724,53.074a.5.5,0,0,1-.356-.85l11.387-11.58a.5.5,0,0,1,.713.7L52.081,52.925A.5.5,0,0,1,51.724,53.074Z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M63.207,52.978a.5.5,0,0,1-.35-.143L51.277,41.448a.5.5,0,0,1,.7-.713L63.558,52.122a.5.5,0,0,1-.351.856Z",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M401.294,74.128c0,.144-78.773.261-175.923.261-97.183,0-175.939-.117-175.939-.261s78.756-.26,175.939-.26C322.521,73.868,401.294,73.985,401.294,74.128Z",
    fill: "#263238"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M64.359,314.228c-.144,0-.26-56.569-.26-126.334,0-69.789.116-126.346.26-126.346s.26,56.557.26,126.346C64.619,257.659,64.5,314.228,64.359,314.228Z",
    fill: "#263238"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M84.858,73.869a36.662,36.662,0,0,1-.26-6.16,36.669,36.669,0,0,1,.26-6.161,36.6,36.6,0,0,1,.261,6.161A36.594,36.594,0,0,1,84.858,73.869Z",
    fill: "#263238"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M105.343,73.869a36.593,36.593,0,0,1-.261-6.16,36.6,36.6,0,0,1,.261-6.161,36.671,36.671,0,0,1,.26,6.161A36.663,36.663,0,0,1,105.343,73.869Z",
    fill: "#263238"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M125.828,73.869a36.593,36.593,0,0,1-.261-6.16,36.6,36.6,0,0,1,.261-6.161,36.8,36.8,0,0,1,.26,6.161A36.79,36.79,0,0,1,125.828,73.869Z",
    fill: "#263238"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M146.313,73.869a36.594,36.594,0,0,1-.261-6.16,36.6,36.6,0,0,1,.261-6.161,36.8,36.8,0,0,1,.26,6.161A36.791,36.791,0,0,1,146.313,73.869Z",
    fill: "#263238"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M166.8,73.869a36.663,36.663,0,0,1-.26-6.16,36.671,36.671,0,0,1,.26-6.161,36.6,36.6,0,0,1,.261,6.161A36.594,36.594,0,0,1,166.8,73.869Z",
    fill: "#263238"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M187.282,73.869a36.663,36.663,0,0,1-.26-6.16,36.671,36.671,0,0,1,.26-6.161,36.67,36.67,0,0,1,.26,6.161A36.662,36.662,0,0,1,187.282,73.869Z",
    fill: "#263238"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M207.767,73.869a36.594,36.594,0,0,1-.261-6.16,36.6,36.6,0,0,1,.261-6.161,36.8,36.8,0,0,1,.26,6.161A36.79,36.79,0,0,1,207.767,73.869Z",
    fill: "#263238"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M228.251,73.869a36.788,36.788,0,0,1-.26-6.16,36.8,36.8,0,0,1,.26-6.161,36.6,36.6,0,0,1,.261,6.161A36.6,36.6,0,0,1,228.251,73.869Z",
    fill: "#263238"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M248.736,73.869a36.663,36.663,0,0,1-.26-6.16,36.671,36.671,0,0,1,.26-6.161A36.6,36.6,0,0,1,249,67.709,36.592,36.592,0,0,1,248.736,73.869Z",
    fill: "#263238"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M269.221,73.869a36.66,36.66,0,0,1-.26-6.16,36.668,36.668,0,0,1,.26-6.161,36.674,36.674,0,0,1,.26,6.161A36.666,36.666,0,0,1,269.221,73.869Z",
    fill: "#263238"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M289.706,73.869a36.6,36.6,0,0,1-.261-6.16,36.6,36.6,0,0,1,.261-6.161,36.668,36.668,0,0,1,.26,6.161A36.66,36.66,0,0,1,289.706,73.869Z",
    fill: "#263238"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M310.191,73.869a36.591,36.591,0,0,1-.261-6.16,36.6,36.6,0,0,1,.261-6.161,36.8,36.8,0,0,1,.26,6.161A36.791,36.791,0,0,1,310.191,73.869Z",
    fill: "#263238"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M330.675,73.869a36.666,36.666,0,0,1-.26-6.16,36.674,36.674,0,0,1,.26-6.161,36.6,36.6,0,0,1,.261,6.161A36.591,36.591,0,0,1,330.675,73.869Z",
    fill: "#263238"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M351.16,73.869a36.66,36.66,0,0,1-.26-6.16,36.668,36.668,0,0,1,.26-6.161,36.672,36.672,0,0,1,.26,6.161A36.664,36.664,0,0,1,351.16,73.869Z",
    fill: "#263238"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M371.645,73.869a36.6,36.6,0,0,1-.261-6.16,36.6,36.6,0,0,1,.261-6.161,36.668,36.668,0,0,1,.26,6.161A36.66,36.66,0,0,1,371.645,73.869Z",
    fill: "#263238"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M392.13,73.869a36.591,36.591,0,0,1-.261-6.16,36.6,36.6,0,0,1,.261-6.161,36.8,36.8,0,0,1,.26,6.161A36.788,36.788,0,0,1,392.13,73.869Z",
    fill: "#263238"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M64.359,91.564a53.614,53.614,0,0,1-7.463.261,53.611,53.611,0,0,1-7.464-.261A53.71,53.71,0,0,1,56.9,91.3,53.713,53.713,0,0,1,64.359,91.564Z",
    fill: "#263238"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M64.359,110.441a53.613,53.613,0,0,1-7.463.261,53.61,53.61,0,0,1-7.464-.261,53.9,53.9,0,0,1,7.464-.26A53.9,53.9,0,0,1,64.359,110.441Z",
    fill: "#263238"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M64.359,129.319a53.715,53.715,0,0,1-7.463.26,53.712,53.712,0,0,1-7.464-.26,53.61,53.61,0,0,1,7.464-.261A53.613,53.613,0,0,1,64.359,129.319Z",
    fill: "#263238"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M64.359,148.2a53.613,53.613,0,0,1-7.463.261,53.61,53.61,0,0,1-7.464-.261,53.712,53.712,0,0,1,7.464-.26A53.715,53.715,0,0,1,64.359,148.2Z",
    fill: "#263238"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M64.359,167.074a53.9,53.9,0,0,1-7.463.26,53.9,53.9,0,0,1-7.464-.26,53.607,53.607,0,0,1,7.464-.261A53.61,53.61,0,0,1,64.359,167.074Z",
    fill: "#263238"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M64.359,185.951a53.715,53.715,0,0,1-7.463.26,53.712,53.712,0,0,1-7.464-.26,53.711,53.711,0,0,1,7.464-.26A53.714,53.714,0,0,1,64.359,185.951Z",
    fill: "#263238"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M64.359,204.828a53.613,53.613,0,0,1-7.463.261,53.61,53.61,0,0,1-7.464-.261,53.711,53.711,0,0,1,7.464-.26A53.714,53.714,0,0,1,64.359,204.828Z",
    fill: "#263238"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M64.359,223.706a53.9,53.9,0,0,1-7.463.26,53.9,53.9,0,0,1-7.464-.26,53.612,53.612,0,0,1,7.464-.261A53.615,53.615,0,0,1,64.359,223.706Z",
    fill: "#263238"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M64.359,242.583a53.711,53.711,0,0,1-7.463.26,53.708,53.708,0,0,1-7.464-.26,53.712,53.712,0,0,1,7.464-.26A53.715,53.715,0,0,1,64.359,242.583Z",
    fill: "#263238"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M64.359,261.46a53.609,53.609,0,0,1-7.463.261,53.606,53.606,0,0,1-7.464-.261,53.9,53.9,0,0,1,7.464-.26A53.9,53.9,0,0,1,64.359,261.46Z",
    fill: "#263238"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M64.359,280.338a53.908,53.908,0,0,1-7.463.26,53.9,53.9,0,0,1-7.464-.26,53.606,53.606,0,0,1,7.464-.261A53.609,53.609,0,0,1,64.359,280.338Z",
    fill: "#263238"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M141.918,78.706a25.367,25.367,0,0,1-16.4,2.59h-.176c-.383-2.207-.549-3.9-.808-5.616-.083-.643-.188-1.3-.322-1.989a.077.077,0,0,0-.01-.041.5.5,0,0,0-.021-.125c-.031.187-.072.363-.1.55a100.68,100.68,0,0,0-1.326,30.016c.777,10.238.517,20.723,1.689,30.826.415,4.093,1.223,8.839.778,13.077a16.617,16.617,0,0,1-.654,3.243,29.134,29.134,0,0,1-8.682,3.368c-14.652,3.658-39.851,3.792-56.057-.353a43.185,43.185,0,0,1-8.527-3.015h-.134c-1.554-4.921-.384-11.139.134-16.32,1.161-10.1.9-20.588,1.678-30.826a100.065,100.065,0,0,0-.808-27.1c-.187-1.129-.395-2.279-.622-3.461-.518,2.59-.622,4.662-1.161,7.771h-.176a25.39,25.39,0,0,1-16.4-2.59A59.59,59.59,0,0,1,36.22,64.2c.4-1.15,5.616-17.293,13.128-21.77,6.041-3.626,15.367-2.756,21.066-7.066h.351c5.524,11.045,16.227,19.511,27.283,10.009,2.932-2.59,5.19-6.393,7.263-10.009,5.7,4.31,15.024,3.44,21.065,7.066C133.9,46.907,139.1,63.049,139.5,64.2A59.075,59.075,0,0,1,141.918,78.706Z",
    transform: "translate(153.736 96.074)",
    fill: "#346b98"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M64.359,299.215a53.711,53.711,0,0,1-7.463.26,53.708,53.708,0,0,1-7.464-.26,53.714,53.714,0,0,1,7.464-.26A53.717,53.717,0,0,1,64.359,299.215Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(48.524 69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(192.75 94.669)",
    style: {
      isolation: "isolate"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M249.874,98.5l-.025.121c-.018.081-.042.209-.084.373a9.788,9.788,0,0,1-.483,1.387,9.956,9.956,0,0,1-1.2,2.032,9.816,9.816,0,0,1-2.3,2.181l-.03-.077,2.657-.4.074-.011-.02.072a16.744,16.744,0,0,1-1.419,3.885,6.457,6.457,0,0,1-1.46,1.783,4.556,4.556,0,0,1-2.2,1.044l0-.122,2.179.192.065.005-.007.065a41.325,41.325,0,0,1-1.742,7.941,65.309,65.309,0,0,1-3.334,8.3c-.462.981-.947,1.939-1.428,2.88l-.166.325.032-.364c.481-5.537,1.072-10.742.717-15.284v-.01l0-.01a43.868,43.868,0,0,1,2.612-7.65,26.029,26.029,0,0,1,1.609-2.972,19.945,19.945,0,0,1,1.713-2.3,14.767,14.767,0,0,1,3-2.67c.191-.133.37-.235.522-.327s.284-.166.393-.221l.32-.166-.318.185c-.2.114-.512.3-.895.561a15.054,15.054,0,0,0-2.971,2.686,20.046,20.046,0,0,0-1.694,2.3A26.155,26.155,0,0,0,242.4,107.2a44.132,44.132,0,0,0-2.584,7.637l0-.02c.366,4.561-.222,9.771-.7,15.307l-.134-.039c.48-.94.963-1.9,1.425-2.876a51.771,51.771,0,0,0,5.077-16.2l.058.071-2.178-.2-.5-.045.5-.077a4.441,4.441,0,0,0,2.142-1.012,6.356,6.356,0,0,0,1.439-1.748,16.711,16.711,0,0,0,1.423-3.856l.054.061-2.659.389-.185.027.156-.1a9.8,9.8,0,0,0,2.3-2.151,10.066,10.066,0,0,0,1.207-2.01,10.556,10.556,0,0,0,.5-1.374Z",
    transform: "translate(-238.949 -98.502)",
    fill: "rgba(66,252,209,0.96)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(185.155 93.217)",
    style: {
      isolation: "isolate"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M218.4,129.367a1.352,1.352,0,0,0,.059-.181c.035-.121.074-.305.121-.547.092-.484.2-1.206.311-2.14.226-1.868.471-4.589.712-7.975a44.892,44.892,0,0,0-.552-11.929,30.084,30.084,0,0,0-2.17-6.773,21.96,21.96,0,0,0-1.854-3.3,29.3,29.3,0,0,0-2.393-3.095l.123-.04c-.147,1.329-.29,2.743-.41,4.174-.108,1.377-.227,2.746-.2,4.087a2.589,2.589,0,0,0,.686,1.789,5.4,5.4,0,0,0,1.527,1.2l.49.266-.538-.135-2.625-.657.086-.066q-.029,1.323-.086,2.608c-.042.857-.082,1.7-.187,2.531-.011.1-.031.207-.05.311a.78.78,0,0,0-.013.285,1.485,1.485,0,0,0,.224.539,5.082,5.082,0,0,0,.779.907,14.542,14.542,0,0,0,1.841,1.459l.168.114h-.2l-2.871,0,.059-.058a20.475,20.475,0,0,0,1.536,7.323,34.918,34.918,0,0,0,2.588,5.167c.828,1.371,1.552,2.4,2.055,3.088.251.346.45.606.584.781l.151.2.051.069s-.018-.018-.056-.062l-.16-.193c-.139-.171-.343-.428-.6-.771-.512-.685-1.246-1.707-2.084-3.075a34.441,34.441,0,0,1-2.619-5.167,20.5,20.5,0,0,1-1.566-7.359v-.059h.06l2.871,0-.034.114a14.6,14.6,0,0,1-1.862-1.47,5.218,5.218,0,0,1-.8-.931,1.609,1.609,0,0,1-.244-.59.925.925,0,0,1,.014-.33c.018-.1.037-.2.048-.3.1-.819.142-1.665.183-2.519s.065-1.725.083-2.6l0-.087.084.021,2.625.655-.049.131a5.527,5.527,0,0,1-1.571-1.231,3.193,3.193,0,0,1-.539-.865,2.646,2.646,0,0,1-.143-.5c-.014-.171-.04-.343-.039-.512-.018-.68.012-1.36.052-2.044s.091-1.371.149-2.061c.12-1.433.264-2.847.411-4.178l.018-.158.105.118a29.318,29.318,0,0,1,2.4,3.113,22.07,22.07,0,0,1,1.863,3.318,30.122,30.122,0,0,1,2.169,6.8,44.663,44.663,0,0,1,.523,11.96c-.254,3.386-.514,6.107-.756,7.975-.12.934-.236,1.655-.337,2.139-.052.242-.1.425-.135.546A.591.591,0,0,1,218.4,129.367Z",
    transform: "translate(-211.296 -93.217)",
    fill: "rgba(66,252,209,0.96)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(196.221 102.344)",
    style: {
      isolation: "isolate"
    }
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M251.6,154.438a.522.522,0,0,1-.01-.158c0-.105.01-.261.025-.466.033-.409.1-1.011.2-1.787.2-1.55.546-3.793,1.007-6.576a34.885,34.885,0,0,1,2.808-9.538,28.428,28.428,0,0,1,1.414-2.537l.8-1.27c.274-.426.516-.869.8-1.31a11.982,11.982,0,0,1,2.128-2.341,19.724,19.724,0,0,1,2.64-1.93l.125-.077-.019.147c-.144,1.119-.309,2.3-.5,3.5-.184,1.133-.357,2.255-.646,3.345a4.026,4.026,0,0,1-.135.405l-.1.194c-.036.062-.079.12-.119.18a2.7,2.7,0,0,1-.609.59,4.617,4.617,0,0,1-1.512.683l-.016-.138,2.254-.013h.086l-.018.085c-.309,1.433-.62,2.834-.8,4.2-.011.085-.015.17-.021.254a.783.783,0,0,1-.055.274,1.352,1.352,0,0,1-.316.433,4.349,4.349,0,0,1-.834.6,12.186,12.186,0,0,1-1.8.823l-.006-.119,2.323.569.058.014-.015.057a16.508,16.508,0,0,1-2.754,5.622,27.834,27.834,0,0,1-3.192,3.611c-.963.923-1.772,1.588-2.33,2.029-.279.221-.5.383-.647.491l-.171.121-.059.037.055-.045.163-.127c.145-.112.36-.279.635-.5.551-.449,1.351-1.121,2.305-2.05a28.191,28.191,0,0,0,3.162-3.618,16.48,16.48,0,0,0,2.716-5.592l.044.071-2.325-.563-.2-.048.191-.071a12.087,12.087,0,0,0,1.776-.817,4.228,4.228,0,0,0,.807-.58,1.228,1.228,0,0,0,.286-.388.64.64,0,0,0,.044-.23c.005-.088.01-.176.021-.262.175-1.382.484-2.778.792-4.216l.068.084-2.254.015-.556,0,.54-.142a4.49,4.49,0,0,0,1.461-.662,2.567,2.567,0,0,0,.577-.559,2.075,2.075,0,0,0,.329-.736c.285-1.073.458-2.2.642-3.328.187-1.195.352-2.379.5-3.5l.106.07a19.636,19.636,0,0,0-2.62,1.913,11.847,11.847,0,0,0-2.106,2.311c-.276.427-.526.882-.8,1.306l-.8,1.269a28.4,28.4,0,0,0-1.413,2.523,35.07,35.07,0,0,0-2.827,9.5c-.473,2.779-.83,5.019-1.05,6.567-.11.774-.185,1.374-.227,1.782S251.6,154.438,251.6,154.438Z",
    transform: "translate(-251.587 -126.449)",
    fill: "rgba(66,252,209,0.96)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(175.257 112.897)",
    style: {
      isolation: "isolate"
    }
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M189.97,184.816l-.034-.52-.077-.627c-.045-.246-.085-.532-.159-.849a31.751,31.751,0,0,0-1.717-5.254q-.332-.814-.732-1.69a17.959,17.959,0,0,0-.908-1.778,17.046,17.046,0,0,0-1.212-1.767c-.446-.589-.914-1.191-1.417-1.789a20.027,20.027,0,0,0-3.533-3.392,11.408,11.408,0,0,0-4.8-2.11l.073-.106A7.425,7.425,0,0,0,179.8,168.3l.3.086-.309.052-2.009.338.047-.108A11.255,11.255,0,0,0,180,171.322a3.854,3.854,0,0,0,2.961.939l.529-.087-.493.21-1.525.649.032-.083a33.361,33.361,0,0,0,3.117,5.078c1.038,1.446,1.995,2.671,2.792,3.673s1.442,1.776,1.883,2.3l.5.6c.116.137.166.2.169.21s-.068-.065-.184-.2l-.519-.589c-.451-.519-1.1-1.287-1.911-2.282s-1.771-2.216-2.818-3.659A33.064,33.064,0,0,1,181.391,173l-.027-.057.06-.026,1.523-.653.036.123a3.981,3.981,0,0,1-3.068-.961,11.363,11.363,0,0,1-2.2-2.682l-.059-.09.106-.018,2.008-.34-.007.138a7.556,7.556,0,0,1-4.43-3.431l-.077-.131.15.025a11.523,11.523,0,0,1,4.854,2.139,20.069,20.069,0,0,1,3.55,3.421c.5.6.971,1.206,1.416,1.8a17.116,17.116,0,0,1,1.214,1.782,17.972,17.972,0,0,1,.906,1.792q.4.879.725,1.7a30.628,30.628,0,0,1,1.679,5.28c.071.319.107.607.147.854s.048.461.064.631Z",
    transform: "translate(-175.257 -164.873)",
    fill: "rgba(66,252,209,0.96)"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(186.139 135.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(0.033 0.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M215,249v2.9h1.356l1.54,9.766h8.6l1.435-9.766h1.3V249Z",
    transform: "translate(-214.999 -248.997)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M214.912,248.827a.36.36,0,0,1,.063,0l.194,0,.762-.008,2.9-.017,10.314-.032h.064v.064c0,.92,0,1.9,0,2.9v.068h-1.369l.068-.059-1.028,7.014-.4,2.753-.009.061h-.061l-8.6-.007h-.055l-.008-.054c-.622-4.012-1.145-7.382-1.515-9.77l.039.033-1.356-.007h-.033v-.032c.008-.945.014-1.672.018-2.17,0-.238.006-.421.008-.551s.006-.182.006-.182,0,.067.006.194,0,.317.008.558c0,.494.01,1.215.019,2.151l-.033-.033,1.356-.006h.033l.005.033,1.564,9.762-.063-.054,8.6-.007-.07.061q.2-1.354.4-2.753c.361-2.451.71-4.82,1.033-7.013l.009-.059h1.361l-.068.068c0-1.006,0-1.983,0-2.9l.064.064-10.272-.032-2.915-.017-.775-.007-.2,0A.573.573,0,0,1,214.912,248.827Z",
    transform: "translate(-214.879 -248.763)",
    fill: "#263238"
  })))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M387.394,295.127c0,.143-68.17.26-152.242.26-84.1,0-152.256-.117-152.256-.26s68.155-.261,152.256-.261C319.224,294.866,387.394,294.983,387.394,295.127Z",
    fill: "#263238"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M266.675,259.345c0,.144-11.642.261-26,.261s-26-.117-26-.261,11.64-.26,26-.26S266.675,259.2,266.675,259.345Z",
    fill: "#263238"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M273.188,247.546l10.406,23.6,3.622-10.383,8.9-3.265Z",
    fill: "#263238"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 13.067,
    height: 13.067,
    transform: "translate(293.046 265.528)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M306.113,278.6a8.394,8.394,0,0,1-.051-.986q-.023-1.032-.059-2.68c-.029-2.347-.068-5.566-.115-9.4l.225.225-13.066.035c-.058.056.492-.492.259-.258v1.776l0,1.747q0,1.729-.007,3.378c-.009,2.19-.018,4.259-.026,6.164l-.225-.225,9.4.115,2.68.059a8.4,8.4,0,0,1,.986.051,5.621,5.621,0,0,1-.893.052l-2.629.059-9.545.114-.224,0V278.6c-.008-1.9-.017-3.974-.026-6.164q0-1.647-.007-3.378,0-.864,0-1.747V265.53c-.233.232.316-.32.261-.263l13.066.036h.228l0,.225c-.046,3.893-.086,7.162-.114,9.545q-.037,1.617-.059,2.629A5.621,5.621,0,0,1,306.113,278.6Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M299.58,277.38a54.322,54.322,0,0,1,0-10.637,54.525,54.525,0,0,1,0,10.637Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M304.9,272.061a54.322,54.322,0,0,1-10.637,0,54.525,54.525,0,0,1,10.637,0Z",
    fill: "#263238"
  })))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 14.358,
    height: 241.008,
    transform: "translate(388.803 74.128)",
    fill: "#455a64"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 14.358,
    height: 49.37,
    rx: 7.179,
    transform: "translate(388.803 102.473)",
    fill: "#263238"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M147.332,154.557a2.117,2.117,0,0,1-.012-.247c0-.178-.008-.409-.013-.706-.006-.64-.015-1.551-.026-2.728-.014-2.4-.034-5.878-.059-10.3-.028-8.851-.067-21.458-.115-36.573l.225.225-50.545.035c-.063.055.488-.489.256-.252v6.872q0,3.411,0,6.758c0,4.459,0,8.823-.007,13.067-.009,8.487-.018,16.5-.026,23.845l-.225-.225,36.575.114,10.295.059,2.727.026.706.013a1.931,1.931,0,0,1,.247.013,1.456,1.456,0,0,1-.222.013l-.681.012-2.684.026-10.244.059-36.719.115h-.225v-.226c-.008-7.348-.017-15.358-.026-23.845,0-4.244,0-8.608-.007-13.067q0-3.345,0-6.758v-6.872c-.233.229.315-.327.265-.269l50.545.035h.226v.225c-.048,15.175-.087,27.831-.115,36.717-.025,4.4-.045,7.858-.059,10.245-.011,1.158-.02,2.055-.026,2.684-.006.287-.01.511-.013.682A1.2,1.2,0,0,1,147.332,154.557Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M102.559,109.783a.8.8,0,0,1,.168-.012l.524-.013,2.065-.026,7.9-.059,28.342-.115h.225v.226c.01,11.341.022,24.719.035,38.993.058-.051-.5.5-.267.264h-5.3l-5.214,0-10.08-.007-18.4-.026h-.226v-.225c.047-11.707.087-21.473.114-28.343.026-3.38.046-6.045.059-7.9q.018-1.325.027-2.065c.005-.215.009-.386.012-.523a.753.753,0,0,1,.013-.169,1.431,1.431,0,0,1,.013.194c0,.144.007.322.012.547q.011.757.026,2.109c.014,1.863.034,4.546.059,7.948.028,6.835.068,16.551.115,28.2l-.225-.225,18.4-.026,10.08-.007,5.214,0h5.3c.236-.233-.309.318-.254.256.013-14.274.025-27.652.036-38.993l.225.225-28.2-.114-7.949-.059-2.109-.026-.548-.013A1.082,1.082,0,0,1,102.559,109.783Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M96.717,103.981a16.605,16.605,0,0,1,3.132,2.7,16.583,16.583,0,0,1,2.766,3.078,16.649,16.649,0,0,1-3.131-2.706A16.671,16.671,0,0,1,96.717,103.981Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M147.149,104.176a15.291,15.291,0,0,1-2.492,3.1,15.27,15.27,0,0,1-2.877,2.743,15.338,15.338,0,0,1,2.493-3.1A15.363,15.363,0,0,1,147.149,104.176Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M146.9,154.657a24.652,24.652,0,0,1-2.454-2.832,24.483,24.483,0,0,1-2.413-2.868,14.462,14.462,0,0,1,4.867,5.7Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M102.181,148.722a15.745,15.745,0,0,1-2.617,3.059,15.748,15.748,0,0,1-2.991,2.7,15.752,15.752,0,0,1,2.618-3.06A15.7,15.7,0,0,1,102.181,148.722Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M111.075,117.567a1.985,1.985,0,0,1,.39-.025l1.186-.027,4.561-.059,16.437-.114.225,0v.227c.01,6.572.022,14.313.035,22.572.058-.054-.495.495-.264.262h-3.069l-3.018,0-5.835-.007-10.648-.026h-.227v-.225c.048-6.768.087-12.422.115-16.437.025-1.929.045-3.462.059-4.561.011-.489.019-.881.026-1.186a2.019,2.019,0,0,1,.026-.39,3.48,3.48,0,0,1,.025.439c.007.317.015.723.026,1.23.014,1.111.034,2.661.059,4.611.028,3.98.067,9.585.115,16.294l-.225-.225,10.648-.026,5.835-.007,3.018,0h3.069c.234-.233-.312.317-.257.258.013-8.259.025-16,.035-22.572l.226.225-16.293-.115-4.612-.059-1.23-.026A3.261,3.261,0,0,1,111.075,117.567Z",
    fill: "#263238"
  }))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M403.161,315.348c0,.144-80.079.26-178.837.26-98.793,0-178.854-.116-178.854-.26s80.061-.261,178.854-.261C323.082,315.087,403.161,315.2,403.161,315.348Z",
    fill: "#263238"
  })))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Tools_2",
    "data-name": "Tools 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 131.338,
    height: 77.141,
    transform: "translate(326.461 168.266)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M457.8,245.407s-.014-.48-.021-1.394-.013-2.276-.022-4.043c-.012-3.552-.029-8.761-.051-15.448-.026-13.365-.062-32.625-.107-56.256l.2.2-131.327.059h-.01l.26-.26c-.007,27.312-.013,53.395-.018,77.141l-.242-.242,94.476.118,27.12.065,7.229.03,1.869.014c.422.005.643.015.643.015s-.2.01-.614.014l-1.841.015-7.181.029-27.065.066-94.636.118h-.242v-.242c-.006-23.746-.012-49.829-.019-77.141v-.261h.271l131.327.059h.2v.2c-.045,23.683-.081,42.986-.107,56.381-.022,6.667-.039,11.861-.051,15.4-.009,1.751-.017,3.09-.022,4.005S457.8,245.407,457.8,245.407Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M352.217,204.281H339.385V191.449h12.832Zm-11.832-1h10.832V192.449H340.385Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 87.321,
    height: 16.761,
    transform: "translate(370.478 168.266)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M365.412,176.391c0,.144-7.022.261-15.683.261s-15.686-.117-15.686-.261,7.022-.26,15.686-.26S365.412,176.248,365.412,176.391Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 11.832,
    height: 11.832,
    transform: "translate(334.519 186.583)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 53.85,
    height: 4.566,
    transform: "translate(365.204 199.064)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M366.222,204.225l-1.74,2.563a.482.482,0,0,0,.4.752h3.431a.482.482,0,0,0,.4-.747l-1.691-2.563A.482.482,0,0,0,366.222,204.225Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 53.85,
    height: 4.566,
    transform: "translate(365.204 212.672)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M415.179,217.833l-1.74,2.563a.482.482,0,0,0,.4.752h3.431a.482.482,0,0,0,.4-.747l-1.691-2.563A.482.482,0,0,0,415.179,217.833Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 53.85,
    height: 4.566,
    transform: "translate(365.204 227.375)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M379.048,232.536l-1.74,2.563a.482.482,0,0,0,.4.752h3.431a.482.482,0,0,0,.4-.747l-1.692-2.563A.481.481,0,0,0,379.048,232.536Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 20.918,
    height: 6.149,
    transform: "translate(425.949 198.273)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 20.918,
    height: 6.149,
    transform: "translate(425.949 211.88)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 20.918,
    height: 6.149,
    transform: "translate(425.949 226.583)",
    fill: "#263238"
  }))))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Tools_1",
    "data-name": "Tools 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 121.252,
    height: 66.151,
    transform: "translate(80.884 336.953)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M202.136,403.105s-.014-.412-.021-1.194-.012-1.948-.022-3.458c-.011-3.04-.028-7.5-.05-13.223-.025-11.448-.061-27.96-.1-48.277l.2.2-121.243.063h-.009l.26-.261c-.006,23.377-.012,45.753-.017,66.151l-.243-.243,87.161.118,25.073.066,6.69.03,1.731.015c.391.005.6.015.6.015s-.187.009-.568.014l-1.7.015-6.641.03-25.017.066-87.323.118H80.64V403.1c0-20.4-.011-42.774-.017-66.151v-.26h.27l121.243.062h.2v.2c-.045,20.368-.081,36.922-.106,48.4-.021,5.707-.038,10.149-.049,13.178-.01,1.494-.017,2.638-.022,3.422S202.136,403.105,202.136,403.105Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M107.553,370.242H95.629V358.318h11.924Zm-10.924-1h9.924v-9.924H96.629Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M103.719,393.384a8.022,8.022,0,0,1-.051-.962c-.015-.674-.035-1.543-.059-2.613-.029-2.289-.068-5.425-.115-9.158l.225.225-12.731.035c-.058.057.492-.492.259-.258v1.731q0,.859,0,1.7,0,1.685-.007,3.292c-.009,2.133-.018,4.149-.026,6.006l-.225-.226,9.159.115,2.612.059a7.838,7.838,0,0,1,.961.052,5.415,5.415,0,0,1-.868.051l-2.562.059-9.3.115-.225,0v-.228c-.008-1.857-.016-3.873-.026-6.006q0-1.6-.006-3.292l0-1.7v-1.731c-.232.232.317-.319.262-.262l12.731.035h.228l0,.225c-.047,3.792-.086,6.976-.115,9.3q-.036,1.574-.059,2.562A5.316,5.316,0,0,1,103.719,393.384Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 80.615,
    height: 15.474,
    transform: "translate(121.521 336.953)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M116.844,344.455c0,.144-6.483.261-14.479.261s-14.481-.117-14.481-.261,6.482-.26,14.481-.26S116.844,344.311,116.844,344.455Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 10.924,
    height: 10.924,
    transform: "translate(91.175 353.864)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 12.733,
    height: 12.733,
    transform: "translate(90.987 380.651)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M103.719,388.831v4.553H99.114Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M118.614,393.384a7.867,7.867,0,0,1-.052-.962c-.015-.674-.035-1.543-.059-2.613-.029-2.289-.068-5.425-.115-9.158l.225.225-12.731.035c-.058.057.492-.492.259-.258v1.731l0,1.7q0,1.685-.007,3.292c-.009,2.133-.018,4.149-.026,6.006l-.225-.226,9.159.115,2.612.059a7.867,7.867,0,0,1,.962.052,5.422,5.422,0,0,1-.869.051l-2.561.059-9.3.115-.224,0v-.228c-.008-1.857-.017-3.873-.026-6.006q0-1.6-.007-3.292l0-1.7v-1.731c-.233.232.316-.319.261-.262l12.731.035h.229l0,.225c-.047,3.792-.086,6.976-.115,9.3q-.036,1.574-.059,2.562A5.42,5.42,0,0,1,118.614,393.384Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 12.733,
    height: 12.733,
    transform: "translate(105.881 380.651)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M118.614,388.831v4.553h-4.605Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M133.508,393.384a7.867,7.867,0,0,1-.052-.962c-.015-.674-.035-1.543-.059-2.613-.028-2.289-.068-5.425-.114-9.158l.225.225-12.732.035c-.058.057.492-.492.259-.258v1.731l0,1.7q0,1.685-.007,3.292c-.009,2.133-.018,4.149-.026,6.006l-.225-.226,9.159.115,2.612.059a7.867,7.867,0,0,1,.962.052,5.422,5.422,0,0,1-.869.051l-2.561.059-9.3.115-.224,0v-.228c-.008-1.857-.017-3.873-.026-6.006q0-1.6-.007-3.292,0-.843,0-1.7v-1.731c-.233.232.316-.319.261-.262l12.732.035h.228l0,.225c-.047,3.792-.086,6.976-.115,9.3q-.036,1.574-.059,2.562A5.421,5.421,0,0,1,133.508,393.384Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 12.733,
    height: 12.733,
    transform: "translate(120.775 380.651)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M133.508,388.831v4.553H128.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M148.4,393.384a7.865,7.865,0,0,1-.052-.962c-.015-.674-.034-1.543-.058-2.613-.029-2.289-.068-5.425-.115-9.158l.225.225-12.732.035c-.058.057.492-.492.26-.258v1.731q0,.859,0,1.7,0,1.685-.007,3.292c-.009,2.133-.018,4.149-.026,6.006l-.225-.226,9.159.115,2.612.059a7.867,7.867,0,0,1,.962.052,5.422,5.422,0,0,1-.869.051l-2.561.059-9.3.115-.224,0v-.228c-.008-1.857-.017-3.873-.026-6.006q0-1.6-.007-3.292,0-.843,0-1.7v-1.731c-.233.232.316-.319.261-.262l12.732.035h.228l0,.225c-.047,3.792-.086,6.976-.115,9.3q-.036,1.574-.059,2.562A5.418,5.418,0,0,1,148.4,393.384Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 12.733,
    height: 12.733,
    transform: "translate(135.669 380.651)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M148.4,388.831v4.553H143.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M163.3,393.384a8.023,8.023,0,0,1-.051-.962c-.016-.674-.035-1.543-.059-2.613-.029-2.289-.068-5.425-.115-9.158l.225.225-12.731.035c-.059.057.492-.492.259-.258v1.731q0,.859,0,1.7,0,1.685-.007,3.292c-.01,2.133-.018,4.149-.026,6.006l-.226-.226,9.159.115,2.612.059a7.867,7.867,0,0,1,.962.052,5.423,5.423,0,0,1-.869.051l-2.561.059-9.3.115-.224,0v-.228c-.008-1.857-.016-3.873-.026-6.006q0-1.6-.007-3.292v-3.433c-.233.232.317-.319.262-.262l12.731.035h.228l0,.225c-.046,3.792-.086,6.976-.114,9.3q-.037,1.574-.059,2.562A5.316,5.316,0,0,1,163.3,393.384Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 12.733,
    height: 12.733,
    transform: "translate(150.563 380.651)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M163.3,388.831v4.553h-4.605Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M178.19,393.384a8.021,8.021,0,0,1-.051-.962c-.015-.674-.035-1.543-.059-2.613-.029-2.289-.068-5.425-.115-9.158l.225.225-12.731.035c-.058.057.492-.492.259-.258v3.433q0,1.685-.007,3.292c-.009,2.133-.018,4.149-.026,6.006l-.225-.226,9.159.115,2.611.059a7.867,7.867,0,0,1,.962.052,5.423,5.423,0,0,1-.869.051l-2.561.059-9.3.115-.225,0v-.228c-.008-1.857-.016-3.873-.026-6.006q0-1.6-.006-3.292l0-1.7v-1.731c-.232.232.317-.319.262-.262l12.731.035h.228l0,.225c-.046,3.792-.086,6.976-.114,9.3q-.036,1.574-.059,2.562A5.316,5.316,0,0,1,178.19,393.384Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 12.733,
    height: 12.733,
    transform: "translate(165.458 380.651)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M178.19,388.831v4.553h-4.605Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M193.084,393.384a8.29,8.29,0,0,1-.051-.962c-.015-.674-.035-1.543-.059-2.613-.029-2.289-.068-5.425-.115-9.158l.225.225-12.731.035c-.058.057.492-.492.259-.258v1.731l0,1.7q0,1.685-.007,3.292c-.009,2.133-.018,4.149-.026,6.006l-.225-.226,9.159.115,2.612.059a7.838,7.838,0,0,1,.961.052,5.4,5.4,0,0,1-.868.051l-2.562.059-9.3.115-.224,0v-.228c-.009-1.857-.017-3.873-.026-6.006q0-1.6-.007-3.292,0-.843,0-1.7v-1.731c-.232.232.317-.319.262-.262l12.731.035h.228l0,.225c-.047,3.792-.086,6.976-.115,9.3q-.036,1.574-.059,2.562A5.316,5.316,0,0,1,193.084,393.384Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 12.733,
    height: 12.733,
    transform: "translate(180.352 380.651)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M193.085,388.831v4.553h-4.605Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 2.801,
    height: 2.801,
    transform: "translate(185.134 358.147)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 2.801,
    height: 2.801,
    transform: "translate(189.023 358.147)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 2.801,
    height: 2.801,
    transform: "translate(185.134 361.803)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 2.801,
    height: 2.801,
    transform: "translate(189.023 361.803)",
    fill: "#263238"
  })))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M411.7,422.021H399.531s-27.47-9.926-33.118-8.977c-5.087.854-23.712,13.227-27.361,15.676a2.311,2.311,0,0,0-.884,1.125h0a3.994,3.994,0,0,0,2.222,5.076l.385.159-.167.555a6.614,6.614,0,0,0-.28,2.222,2.685,2.685,0,0,0,4.99,1.16l-.7,1.247a3.058,3.058,0,0,0-.389,1.668l.063,1.133a3.053,3.053,0,0,0,2.1,2.736h0a3.042,3.042,0,0,0,3.2-.839c2.362-2.6,7.745-6.4,11.2-6.97,3.069-.512,7.9-1.986,10.994-1.972a3.82,3.82,0,0,1,3.545,2.44h0c-2.049.146-12.614,4.959-17.665,7.623a5.4,5.4,0,0,0-2.937,4.065c-.185,1.581.614,3.237,3.741,2.507,6.711-1.567,15.081-4.489,15.081-4.489s6.23-1.78,10.266,1.068c5.677,4.005,8.278,5.474,13.153,3.857a41.246,41.246,0,0,0,8.469-3.935l9.605-.959S424.122,425.5,411.7,422.021Z",
    fill: "#ffbe9d"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M409.107,443.371a4.453,4.453,0,0,1-.646.474,5.088,5.088,0,0,1-.837.5,8.312,8.312,0,0,1-1.212.55,13.255,13.255,0,0,1-8.368.279,12.971,12.971,0,0,1-5.147-2.795l-.6-.543-.541-.616a11.15,11.15,0,0,1-1-1.348c-.613-.955-1.065-2.018-1.727-2.952a4.233,4.233,0,0,0-2.744-1.894,13.353,13.353,0,0,0-3.683.029,21.718,21.718,0,0,1-7.932-.785,22.873,22.873,0,0,1-6.818-3.255,23.721,23.721,0,0,1-2.776-2.309,1.74,1.74,0,0,1-.459-1.845,1.761,1.761,0,0,1,1.454-1.171h.017l17.848-.742,5.117-.17,1.361-.026a2.052,2.052,0,0,1,.471.019,2.1,2.1,0,0,1-.467.062l-1.358.1-5.11.308-17.839.93h.017a1.265,1.265,0,0,0-1.045.851,1.235,1.235,0,0,0,.343,1.327,23.413,23.413,0,0,0,2.72,2.248,22.534,22.534,0,0,0,6.668,3.172,21.362,21.362,0,0,0,7.746.778,13.689,13.689,0,0,1,3.825-.009,4.507,4.507,0,0,1,1.76.758,5.575,5.575,0,0,1,1.276,1.348c.694.994,1.139,2.066,1.725,2.988a10.765,10.765,0,0,0,.949,1.3l.515.6.569.529a12.7,12.7,0,0,0,4.963,2.763,13.3,13.3,0,0,0,8.194-.117A19.7,19.7,0,0,0,409.107,443.371Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M546.494,135.086a10.88,10.88,0,0,0-11.707-4.616,14.875,14.875,0,0,0-18.232,1.8,13.231,13.231,0,0,0-19.04,12.372,11.056,11.056,0,0,0-8.146,19.341,10.627,10.627,0,0,0,6.105,20.246l50.032-36.6A10.88,10.88,0,0,0,546.494,135.086Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M494.053,185.84a45.089,45.089,0,0,1,41.508-44.908l2.327-.186c25.215-.536,39.756,20.579,39.595,45.8l3.033,83.865-2.6,10.785L543.968,309.22l-17.053-15.1-4.9-24.71s-24.427-1.827-26.65-25.926C494.294,231.843,494.034,207.7,494.053,185.84Z",
    fill: "#ffbe9d"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M521.814,269.388s15.479-.3,30.87-11.773c0,0-6.049,17.954-30.293,17.7Z",
    fill: "#eb996e"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M502.826,207.622a3.455,3.455,0,0,0,3.6,3.21,3.305,3.305,0,0,0,3.3-3.389,3.458,3.458,0,0,0-3.6-3.213A3.308,3.308,0,0,0,502.826,207.622Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M500.009,198.475c.462.415,2.917-1.725,6.626-2.01,3.7-.339,6.572,1.351,6.937.865.182-.217-.318-.993-1.571-1.761a9.481,9.481,0,0,0-5.6-1.248,9.106,9.106,0,0,0-5.229,2.161C500.1,197.447,499.781,198.291,500.009,198.475Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M534.723,206.675a3.455,3.455,0,0,0,3.6,3.21,3.3,3.3,0,0,0,3.3-3.39,3.458,3.458,0,0,0-3.6-3.212A3.307,3.307,0,0,0,534.723,206.675Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M535.431,195.13c.463.415,2.922-1.724,6.628-2.01,3.7-.338,6.572,1.351,6.938.865.181-.217-.315-.993-1.573-1.76a9.468,9.468,0,0,0-5.6-1.249,9.112,9.112,0,0,0-5.23,2.161C535.529,194.1,535.206,194.946,535.431,195.13Z",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M525.413,223.578c0-.213-2.335-.427-6.107-.607-.954-.021-1.865-.138-2.076-.772a4.83,4.83,0,0,1,.408-2.856q1.06-3.542,2.224-7.431c3.069-10.573,5.209-19.236,4.783-19.356s-3.261,8.353-6.329,18.926q-1.1,3.908-2.1,7.465c-.271,1.1-.791,2.374-.194,3.754a2.383,2.383,0,0,0,1.666,1.26,6.449,6.449,0,0,0,1.626.1C523.084,223.958,525.415,223.789,525.413,223.578Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M536.528,225.272c-.606.012-.293,4.037-3.509,7.167s-7.535,3.03-7.521,3.6c-.036.257,1.017.705,2.832.61a10.051,10.051,0,0,0,6.3-2.772,8.757,8.757,0,0,0,2.684-5.99C537.33,226.186,536.8,225.226,536.528,225.272Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M534.539,184.545c.517.927,3.641-.191,7.526-.437,3.878-.334,7.179.3,7.5-.686.137-.471-.581-1.3-2.008-2.007a11.613,11.613,0,0,0-5.876-1.058,11.162,11.162,0,0,0-5.572,1.914C534.849,183.182,534.307,184.1,534.539,184.545Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M500.038,188.242c.652.846,3.215-.025,6.3-.058,3.08-.141,5.689.582,6.29-.3.265-.428-.143-1.275-1.281-2.078a9.122,9.122,0,0,0-10.143.289C500.11,186.96,499.75,187.829,500.038,188.242Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M495.491,174.591s5.157-15.614,12.16-19.72c8.478-4.971,13.047,4.4,21.263,1.386s16.309-7.787,25.416-1.975c9.968,6.36,5.961,11.7,7.4,22.358,5.817,43.206,14.72,54.846,15.344,34.226.068-2.259,6.14-4.536,6.307-14.07.215-12.364-.5-27.3-3.934-35.786-2.894-7.155-7.482-11.891-15.431-16.882-12.548-7.879-28.832-6.771-39.792-4.777S492.975,155.756,495.491,174.591Z",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M575.48,210.332a6.568,6.568,0,0,1,6.566-6.874c4.533.069,9.743,2.224,10.188,11.545.789,16.533-15.973,13.915-16.024,13.442C576.175,228.124,575.749,217.254,575.48,210.332Z",
    fill: "#ffbe9d"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M579.51,222.053c.07-.057.3.188.795.388a2.885,2.885,0,0,0,2.155-.059c1.716-.724,3.055-3.567,2.993-6.552a9.532,9.532,0,0,0-1-4.084,3.333,3.333,0,0,0-2.272-2.108,1.466,1.466,0,0,0-1.662.871c-.2.472-.079.8-.165.83-.045.044-.368-.26-.268-.949a1.841,1.841,0,0,1,.6-1.067,2.176,2.176,0,0,1,1.573-.5,4.054,4.054,0,0,1,3.131,2.42,9.787,9.787,0,0,1,1.218,4.56c.054,3.337-1.5,6.536-3.86,7.341a3.091,3.091,0,0,1-2.656-.311C579.559,222.451,579.455,222.085,579.51,222.053Z",
    fill: "#eb996e"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M572.608,178.4c-2.025,1.633-4.167,3.321-6.728,3.782s-5.63-.785-6.269-3.307c-.287-1.132-.113-2.486-.938-3.314-.985-.986-2.62-.522-3.991-.265a10.562,10.562,0,0,1-11.528-6.676c-1.076,1.928-3.937,2.077-5.883,1.031s-3.293-2.9-4.874-4.445-3.731-2.865-5.886-2.381c-1.206.271-2.289,1.088-3.524,1.076-2.182-.019-3.441-2.471-3.94-4.594s-.955-4.611-2.882-5.633c-1.786-.948-3.939-.146-5.91.307s-4.581.19-5.247-1.719a3.925,3.925,0,0,1,.5-3.05,10.716,10.716,0,0,1,12.286-5.049,14.523,14.523,0,0,1,26.375-4.928,14.739,14.739,0,0,1,23.913,3.483,10.683,10.683,0,0,1,13.243,14.533c3.1,1.457,5.873,4.2,6.206,7.609s-2.72,7.075-6.085,6.44a5.917,5.917,0,0,1-9.732,6.7",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M582.651,171.172c.054-.048.415,1.362-.774,3.252a5.319,5.319,0,0,1-3.148,2.235,5.734,5.734,0,0,1-4.811-.992l.689-.16a16.5,16.5,0,0,1-2.964,4.375,9.486,9.486,0,0,1-2.856,2.108,7.346,7.346,0,0,1-8.272-1.776,9.563,9.563,0,0,1-1.608-3.325,3.281,3.281,0,0,1-.234-1.323c.07-.021.246.421.583,1.2a11.117,11.117,0,0,0,1.774,3.015c1.751,2.241,6.941,3.043,9.928-.558a16.607,16.607,0,0,0,2.832-4.1l.252-.509.438.349a5.025,5.025,0,0,0,4.077.95,4.878,4.878,0,0,0,2.86-1.811A8.044,8.044,0,0,0,582.651,171.172Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M548.484,135.992c.013.056-.421.15-1.133.52a5.7,5.7,0,0,0-2.388,2.382l-.172.33-.252-.287a20.614,20.614,0,0,0-8.489-5.821,16.081,16.081,0,0,0-6.607-.907,13.445,13.445,0,0,0-6.825,2.553,13.651,13.651,0,0,0-3.844,4.274,11.2,11.2,0,0,0-1.417,5.117l-.01.526-.511-.1a9.284,9.284,0,0,0-6.788,1.381,9.065,9.065,0,0,0-3.429,4.317,12.37,12.37,0,0,0-.638,4.968,3.368,3.368,0,0,1-.307-1.333,9.19,9.19,0,0,1,.443-3.814,9.407,9.407,0,0,1,3.517-4.746A9.939,9.939,0,0,1,517,143.718l-.521.428a11.938,11.938,0,0,1,1.479-5.562,14.382,14.382,0,0,1,4.1-4.593,14.173,14.173,0,0,1,7.313-2.7,16.6,16.6,0,0,1,6.961,1.043,20.123,20.123,0,0,1,8.6,6.272l-.425.042a5.616,5.616,0,0,1,2.726-2.383A2.478,2.478,0,0,1,548.484,135.992Z",
    fill: "#455a64"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M640.277,368.993c-.9,0-2.8-77.45-2.8-77.45l-52.89-18.886L543.968,309.22l-20.707-32.6-18.2,8.372c-2.3,1.057-12.385,5.1-14.4,6.631-5.774,4.409-17.846,14.965-21.255,27.84-5.2,19.649-13.364,85.006-13.364,85.006l-49.678,17.552,1.08,31.96,48.614,7.609c11.734-.424,25.935-5.377,30.51-13.519v17.075H635.926S641.181,368.993,640.277,368.993Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M488.359,339.543a1.5,1.5,0,0,1,.019.321c0,.241,0,.551.005.942-.01.862-.025,2.075-.043,3.619-.056,3.143-.194,7.69-.44,13.3s-.6,12.3-.867,19.718-.372,15.585-.42,24.157c-.086,17.15-.039,32.675-.036,43.913,0,5.593,0,10.131,0,13.308-.01,1.544-.017,2.757-.022,3.619-.008.39-.014.7-.019.941a1.486,1.486,0,0,1-.024.321,1.457,1.457,0,0,1-.029-.321c-.009-.24-.02-.55-.033-.941-.018-.861-.044-2.073-.076-3.617-.038-3.178-.094-7.715-.162-13.308-.1-11.238-.2-26.764-.117-43.918.048-8.573.157-16.746.461-24.172s.691-14.106.979-19.717.487-10.153.606-13.293c.059-1.543.106-2.754.14-3.615.019-.391.035-.7.047-.941A1.5,1.5,0,0,1,488.359,339.543Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M488.359,346.894c-8.474,31.941-10.718,66.548-2.212,98.481C486.313,409.818,486.107,376.53,488.359,346.894Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M612.75,350.211l9.285,59.818a4.074,4.074,0,0,0,.652,1.939c.989,1.259,2.944.934,4.482.488,3.743-1.088,9.63-1.489,11.653-4.822l.49-8.518c-.546-2.58-3.046-5.057-4.216-7.42L613.337,347.72"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M637.076,291.4s17.272,9.721,23.673,23.4c7.806,16.685,42.376,76.819,43.652,91.821,1.279,15.031.756,32.142-24.833,37.26s-52.3,4.766-52.3,4.766L616.827,417.57l29.334-15.153-7.311-6.422a17.129,17.129,0,0,1-3.9-4.978l-22.068-42.495",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M612.882,348.522s.194.332.548.993l1.558,2.938,5.929,11.3c2.565,4.911,5.7,10.907,9.326,17.857l2.813,5.392q.724,1.392,1.473,2.827a24.8,24.8,0,0,0,1.613,2.833,17.023,17.023,0,0,0,2.144,2.556c.81.778,1.712,1.521,2.584,2.3q2.643,2.316,5.42,4.749l.217.19-.256.132-29.319,15.183.112-.277c3.257,9.681,6.778,20.146,10.454,31.075l-.232-.169c8.484.016,17.348-.392,26.437-1.191,4.546-.394,9.149-.9,13.786-1.566s9.332-1.387,13.968-2.489l2.305-.56c.76-.212,1.494-.5,2.241-.744.738-.269,1.5-.48,2.215-.794l2.125-.987c.352-.167.711-.323,1.057-.5l.992-.611c.657-.412,1.329-.8,1.971-1.229a25.9,25.9,0,0,0,3.455-3.047,21.343,21.343,0,0,0,4.757-7.7,33.294,33.294,0,0,0,1.815-8.793,70.308,70.308,0,0,0-.04-8.88,27.525,27.525,0,0,0-1.56-8.515c-.87-2.741-1.914-5.4-2.993-8s-2.213-5.155-3.349-7.665c-4.6-10.016-9.379-19.351-13.884-28.062s-8.812-16.772-12.706-24.15l-5.517-10.546c-.859-1.673-1.689-3.3-2.469-4.889l-1.137-2.356c-.378-.768-.778-1.5-1.156-2.236a44.888,44.888,0,0,0-5.355-7.465,68.459,68.459,0,0,0-5.5-5.45,83.577,83.577,0,0,0-8.5-6.543c-1.017-.686-1.809-1.186-2.342-1.521s-.8-.508-.8-.508.289.145.833.462,1.344.806,2.372,1.48a79.507,79.507,0,0,1,8.573,6.477,67.931,67.931,0,0,1,5.555,5.438,44.9,44.9,0,0,1,5.424,7.488c.384.738.793,1.482,1.175,2.25l1.143,2.346c.785,1.584,1.621,3.207,2.484,4.875l5.548,10.526c3.915,7.366,8.23,15.421,12.764,24.122s9.314,18.037,13.938,28.062c1.141,2.513,2.288,5.062,3.364,7.678s2.135,5.277,3.015,8.04a27.989,27.989,0,0,1,1.589,8.634,70.468,70.468,0,0,1,.045,8.95,33.742,33.742,0,0,1-1.84,8.933,21.853,21.853,0,0,1-4.863,7.879,26.468,26.468,0,0,1-3.53,3.115c-.654.438-1.338.834-2.008,1.253l-1.01.622c-.352.179-.716.337-1.073.507l-2.158,1c-.727.319-1.495.533-2.243.8-.755.249-1.5.539-2.268.754l-2.327.566c-4.676,1.11-9.369,1.832-14.017,2.5s-9.259,1.172-13.813,1.565c-9.108.8-17.975,1.2-26.488,1.175h-.176l-.057-.169c-3.664-10.933-7.172-21.4-10.417-31.087l-.062-.186.174-.09,29.348-15.125-.039.322-5.408-4.763c-.875-.784-1.758-1.514-2.593-2.32a17.284,17.284,0,0,1-2.182-2.616,25.082,25.082,0,0,1-1.625-2.874l-1.465-2.831-2.793-5.4-9.243-17.9c-2.527-4.916-4.494-8.741-5.836-11.351q-.987-1.941-1.507-2.964C613.042,348.872,612.882,348.522,612.882,348.522Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M629.209,290.35a16.531,16.531,0,0,1-1.6,1.032,42.457,42.457,0,0,0-4.194,3.025,39.268,39.268,0,0,0-14.549,29.633,42.3,42.3,0,0,0,.171,5.168,16.652,16.652,0,0,1,.163,1.9,1.743,1.743,0,0,1-.124-.479c-.057-.318-.165-.784-.24-1.4a34.84,34.84,0,0,1-.338-5.2,38.208,38.208,0,0,1,14.687-29.914,34.7,34.7,0,0,1,4.32-2.911c.528-.314.964-.514,1.25-.664A1.818,1.818,0,0,1,629.209,290.35Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M677.319,389.851a6.459,6.459,0,0,1-1.281.368l-3.513.881a100.133,100.133,0,0,0-11.346,3.66,84.806,84.806,0,0,0-10.741,5.162c-1.325.759-2.388,1.393-3.113,1.845a6.677,6.677,0,0,1-1.164.65,6.436,6.436,0,0,1,1.052-.819c.694-.506,1.73-1.19,3.038-1.993a70.665,70.665,0,0,1,10.736-5.329,80.867,80.867,0,0,1,11.45-3.534c1.5-.34,2.713-.584,3.559-.721A6.57,6.57,0,0,1,677.319,389.851Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M583.1,274.486a9.431,9.431,0,0,0-4.2,2.089,203.434,203.434,0,0,0-33.08,30.494l-1.683,3.113c3.724-2.466,7.987-5.045,12.359-4.129,3.736.783,6.453,3.916,8.877,6.865a310.888,310.888,0,0,0,24.461-35.609C587.848,275.783,585.578,274.172,583.1,274.486Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M543.968,309.22l14.921-18.87,22.44-26.79,11.916,11.186-20.892,32.359-14.84-8.929Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M517.053,284.821c1.986,10.624,6.909,19.476,8.9,30.1,2.371-3.1,1.8-4.422,4.176-7.518a8.527,8.527,0,0,1,3.461-3.1c2.559-.978,5.368.5,7.684,1.918a86.758,86.758,0,0,0-11.928-10.934l-.179.856q-5.991-7.45-12.3-14.669"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M543.741,309.106,522.78,273.391h0l-7.494,6.9,7.1,31.963L532.436,299.3Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M542.9,307.675s-.136-.195-.378-.59l-1.062-1.758-4.043-6.791c-3.5-5.925-8.553-14.478-14.8-25.05l.284.046c-2.38,2.086-4.909,4.3-7.547,6.617l.064-.2c2.162,9.682,4.585,20.534,7.2,32.247l-.428-.1,10.044-12.962.164-.211.2.175,11.308,9.807-.218-.058,1.214-.235-.122.06c3.63-3.227,7.647-6.416,11.561-9.82l1-.875.136-.12.158.084c5.22,2.782,9.9,6.232,14.842,8.933l-.34.086,20.911-32.346.036.3-11.9-11.2.314-.021-26.359,32.034-7.362,8.894-1.946,2.326c-.443.524-.684.783-.684.783s.206-.288.632-.825l1.9-2.366,7.271-8.969,26.217-32.15.145-.178.169.158,11.929,11.172.142.134-.106.164L572.57,307.246l-.13.2-.211-.115c-4.986-2.721-9.665-6.17-14.837-8.925l.294-.035-1,.878c-3.926,3.416-7.942,6.6-11.56,9.815l-.053.047-.07.014-1.214.234-.124.023-.1-.082-11.3-9.815.365-.036L522.575,312.4l-.317.407-.111-.5c-2.588-11.719-4.986-22.576-7.125-32.263l-.027-.119.092-.08,7.57-6.591.171-.148.113.2c6.185,10.608,11.188,19.19,14.655,25.135,1.712,2.96,3.043,5.262,3.957,6.841l1.017,1.785C542.8,307.461,542.9,307.675,542.9,307.675Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M486.979,299.968c.144.005.05,6.506-.21,14.519s-.586,14.508-.73,14.5-.05-6.505.21-14.521S486.835,299.964,486.979,299.968Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M575.7,421.332a10.326,10.326,0,0,0-3.65,1.332c-2.68,1.806-3.276,5.43-3.634,8.642-.112,1.006-.137,2.219.691,2.8a2.847,2.847,0,0,0,2.462.009,76.759,76.759,0,0,0,15.731-6.987c2.645-1.552,5.377-3.495,6.271-6.428l.173-1.257A74.978,74.978,0,0,0,575.7,421.332Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M599.347,395.282c-9.787,11.772-46.211,55.271-46.211,55.271l-1.381,6.241a.5.5,0,0,0,.667.569l5.856-2.313,47.05-54.7a3.921,3.921,0,0,0-.581-5.664h0A3.914,3.914,0,0,0,599.347,395.282Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M595.845,399.486l5.94,4.983,1.654-1.923-5.964-5.016Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M588.733,415.523a2.085,2.085,0,0,1-1.356-.5l-.044-.04a2.1,2.1,0,0,1-.2-2.921l6.827-8.036a2.1,2.1,0,1,1,3.2,2.718l-6.827,8.037a2.09,2.09,0,0,1-1.43.734C588.849,415.521,588.791,415.523,588.733,415.523Zm-1.154-.658a1.852,1.852,0,0,0,2.567-.245l6.826-8.037a1.849,1.849,0,1,0-2.819-2.394l-6.826,8.036a1.846,1.846,0,0,0,.212,2.606Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M593.657,410.7c-.1.106-.821-.406-1.614-1.142s-1.357-1.418-1.259-1.524.82.406,1.614,1.143S593.754,410.6,593.657,410.7Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M617.189,419.4l-9.175,3.212s-8.437-2.116-11.95-2.935a9.207,9.207,0,0,0-7.111,1.242c-4.325,2.8-11.753,7.624-14.413,9.392-2.617,1.739-9.453,7.4-9.453,7.4s-4.932,5.643-3.32,8.889,6.072,2.773,6.072,2.773a6.725,6.725,0,0,0,5.339,5.031s-1.122,1.765,3.093,2.88,14.008,0,14.008,0,17.975.744,19.71-.123,9.294-8.588,9.294-8.588l6.419-3.836Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M581.642,425.635a21.986,21.986,0,0,1-2.745,2c-1.727,1.187-4.144,2.78-6.723,4.656a65.518,65.518,0,0,0-6.313,5.161c-1.523,1.427-2.4,2.384-2.463,2.329a3.1,3.1,0,0,1,.535-.745c.367-.46.936-1.1,1.671-1.848a49.3,49.3,0,0,1,6.263-5.318c2.6-1.888,5.05-3.435,6.829-4.544A22.019,22.019,0,0,1,581.642,425.635Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M590.039,434.027a4.28,4.28,0,0,1-.912.563l-2.558,1.386c-2.155,1.173-5.13,2.8-8.252,4.854a60.938,60.938,0,0,0-7.567,5.831c-1.811,1.648-2.846,2.763-2.911,2.7a4.249,4.249,0,0,1,.654-.851c.442-.529,1.124-1.258,2-2.122a50.037,50.037,0,0,1,7.533-6,79.452,79.452,0,0,1,8.37-4.746c1.1-.543,2.006-.966,2.637-1.241A4.222,4.222,0,0,1,590.039,434.027Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M599.15,440.623a4.645,4.645,0,0,1-.832.8c-.562.487-1.4,1.158-2.481,1.938-2.145,1.575-5.29,3.478-8.769,5.531a46.853,46.853,0,0,1-9.523,4.145c-1.263.408-2.294.709-3.009.905a4.871,4.871,0,0,1-1.128.252,5.03,5.03,0,0,1,1.066-.445l2.952-1.06a54.734,54.734,0,0,0,9.376-4.245c3.485-2.056,6.639-3.9,8.825-5.385,1.1-.737,1.967-1.359,2.565-1.795A5.243,5.243,0,0,1,599.15,440.623Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M603.05,448.651a7.783,7.783,0,0,1-1.536,1.58,34.468,34.468,0,0,1-8.947,5.683,7.778,7.778,0,0,1-2.083.718c-.062-.148,3.033-1.439,6.5-3.653C600.458,450.785,602.942,448.532,603.05,448.651Z",
    fill: "#eb996e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M653.838,465.644H518.217a8.73,8.73,0,0,1,8.73-8.73H645.109a8.729,8.729,0,0,1,8.729,8.73Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M489.918,458.187l-62.72-.3L405.941,357.214a8.955,8.955,0,0,0-8.769-7.14H266.1a8.955,8.955,0,0,0-8.75,10.864l21.594,99.018A7.229,7.229,0,0,0,286,465.644H499.026C499.026,460.551,495.011,458.187,489.918,458.187Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M423.075,465.644c-.141.031-6.054-25.817-13.205-57.726s-12.839-57.812-12.7-57.844,6.052,25.811,13.206,57.731S423.215,465.612,423.075,465.644Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M345.582,406.381c3.108,4.183,2.62,9.808-1.089,12.563s-9.235,1.6-12.343-2.583-2.62-9.807,1.089-12.563S342.475,402.2,345.582,406.381Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 9.082,
    height: 4.163,
    rx: 2.081,
    transform: "translate(451.733 459.543)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M548.46,461.206a2.232,2.232,0,0,1,.267.29,2.659,2.659,0,0,1,.456,1.062,4.3,4.3,0,0,1-1.653,3.965,5.966,5.966,0,0,1-3.006,1.128,16.279,16.279,0,0,1-3.816-.105,22.1,22.1,0,0,0-4.315-.251,7.024,7.024,0,0,0-2.254.525,3.3,3.3,0,0,0-1.776,1.493,2.134,2.134,0,0,0,.486,2.241,5.278,5.278,0,0,0,2.158,1.492,20.091,20.091,0,0,1,2.652,1.147,3.553,3.553,0,0,1,1.829,2.441,4.9,4.9,0,0,1-3.309,5.081c-2.083.829-4.364.774-6.618.835a110.7,110.7,0,0,1-14.211-.92c-4.9-.575-9.956-1.3-15.156-1.768a80.122,80.122,0,0,0-15.2-.035c-4.9.456-9.628,1.134-14.184,1.215a23.911,23.911,0,0,1-6.639-.6,9.274,9.274,0,0,1-5.3-3.353,6.665,6.665,0,0,1-1.233-5.684,4.045,4.045,0,0,1,4.246-3,2.306,2.306,0,0,1,1.949,1.66,3.079,3.079,0,0,1-2.427,3.661,3.8,3.8,0,0,1-2.149-.293,5.081,5.081,0,0,1-2.625-2.75,9.3,9.3,0,0,1-.663-3.144c-.076-1.93.1-3.411.1-4.419.008-.5,0-.887-.008-1.145a2.529,2.529,0,0,1,0-.392,1.865,1.865,0,0,1,.057.388c.027.258.051.644.06,1.149.039,1.011-.106,2.5,0,4.406a9.17,9.17,0,0,0,.689,3.058,4.822,4.822,0,0,0,2.512,2.581,3.5,3.5,0,0,0,1.98.254,2.647,2.647,0,0,0,1.72-1.141,2.608,2.608,0,0,0,.424-2.119,1.945,1.945,0,0,0-1.662-1.389,3.666,3.666,0,0,0-3.81,2.745,6.26,6.26,0,0,0,1.2,5.316,8.839,8.839,0,0,0,5.067,3.167,23.593,23.593,0,0,0,6.512.558c4.517-.094,9.228-.779,14.147-1.244a80.011,80.011,0,0,1,15.294.025c5.22.465,10.277,1.2,15.169,1.779a111.429,111.429,0,0,0,14.147.947c2.246-.05,4.5,0,6.451-.779a4.964,4.964,0,0,0,2.364-1.831,3.906,3.906,0,0,0,.692-2.753,3.134,3.134,0,0,0-1.617-2.156,20.272,20.272,0,0,0-2.591-1.133,5.66,5.66,0,0,1-2.3-1.619,3.185,3.185,0,0,1-.65-1.245,2.176,2.176,0,0,1,.126-1.391A3.623,3.623,0,0,1,534,467.5a7.31,7.31,0,0,1,2.366-.533,22.174,22.174,0,0,1,4.375.292,16.236,16.236,0,0,0,3.752.148,5.783,5.783,0,0,0,2.909-1.042,4.206,4.206,0,0,0,1.675-3.787A3.049,3.049,0,0,0,548.46,461.206Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M652.223,461.247c0,.143-29.762.26-66.466.26s-66.471-.117-66.471-.26,29.755-.261,66.471-.261S652.223,461.1,652.223,461.247Z",
    fill: "#455a64"
  })))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M602.284,163.387l17.429-2.663a53.391,53.391,0,1,0-13.833-13.215l-.023-.019Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M602.284,163.387s.064-.334.209-1.012.369-1.7.657-3.032l2.6-11.877a.108.108,0,0,1,.129-.083.111.111,0,0,1,.046.023l.023.018-.157.149a53.736,53.736,0,0,1-5.852-10.195,52.869,52.869,0,0,1-3.945-14.062,52.281,52.281,0,0,1-.47-8.295,58.532,58.532,0,0,1,.974-8.865,53.093,53.093,0,0,1,7.022-18.13A53.885,53.885,0,0,1,639.6,63.452a54.249,54.249,0,0,1,24.579,1.416,55.127,55.127,0,0,1,11.823,5.046l2.738,1.779,1.374.893c.45.311.863.673,1.3,1.008l2.579,2.053c.843.708,1.6,1.516,2.407,2.272a50.492,50.492,0,0,1,4.391,4.809l.527.616.468.661.928,1.323c.6.892,1.272,1.737,1.813,2.661l1.58,2.789c.259.465.533.923.779,1.393l.647,1.455,1.288,2.9c.4.977.681,1.992,1.025,2.982a53.146,53.146,0,0,1-5.9,45.658,53.472,53.472,0,0,1-32.473,22.995l-2.22.5-1.1.243-1.107.134c-1.47.171-2.914.363-4.337.508a71.861,71.861,0,0,1-8.279-.083,53.133,53.133,0,0,1-24.787-8.639l.078.017-13.022,1.92-3.317.481c-.741.107-1.106.151-1.106.151s.394-.072,1.147-.194l3.341-.536,12.923-2.044a.116.116,0,0,1,.08.017,53.13,53.13,0,0,0,24.693,8.484,71.729,71.729,0,0,0,8.223.055c1.413-.148,2.847-.343,4.306-.517l1.1-.135,1.089-.244,2.2-.5a52.963,52.963,0,0,0,37.97-68.108c-.341-.98-.624-1.985-1.015-2.952q-.637-1.431-1.277-2.87l-.641-1.44c-.244-.466-.516-.919-.772-1.38l-1.566-2.761c-.535-.915-1.2-1.752-1.8-2.635l-.92-1.311-.463-.654-.522-.61a50.026,50.026,0,0,0-4.349-4.762c-.8-.748-1.549-1.549-2.383-2.25L681.1,74.008c-.43-.332-.838-.691-1.283-1l-1.361-.884-2.711-1.762a54.606,54.606,0,0,0-11.707-5,53.113,53.113,0,0,0-60.145,22.894,52.776,52.776,0,0,0-7.008,17.973,58.365,58.365,0,0,0-.992,8.8,52.053,52.053,0,0,0,.441,8.242,52.78,52.78,0,0,0,3.866,14,53.878,53.878,0,0,0,5.769,10.179.109.109,0,0,1-.023.152.113.113,0,0,1-.134,0l-.023-.019.175-.06c-1.185,5.137-2.1,9.09-2.715,11.774q-.466,2-.711,3.05C602.376,163.026,602.284,163.387,602.284,163.387Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M664.285,138.509l-13.234,6.014a12.792,12.792,0,0,1-16.938-6.353l-12.966-28.533,36.526-16.6,12.966,28.533A12.792,12.792,0,0,1,664.285,138.509Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M664.285,138.509a17.77,17.77,0,0,0,3.13-2.123,13.2,13.2,0,0,0,2.738-3.542,12.453,12.453,0,0,0,1.468-5.786,11.78,11.78,0,0,0-.455-3.5,22.558,22.558,0,0,0-1.457-3.6c-1.133-2.475-2.353-5.138-3.65-7.969-2.59-5.672-5.486-12.015-8.609-18.852l.324.121-24.87,11.32-11.65,5.29.127-.34,10.774,23.782c.827,1.8,1.592,3.589,2.4,5.254a12.569,12.569,0,0,0,12.238,6.878c2.94-.18,5.28-1.623,7.422-2.508l5.439-2.427L663.084,139l.892-.38a1.723,1.723,0,0,1,.309-.114,1.648,1.648,0,0,1-.29.158l-.872.422-3.388,1.589-5.4,2.5-3.4,1.555a12.94,12.94,0,0,1-16.753-5.973c-.836-1.7-1.6-3.457-2.434-5.261l-10.83-23.756-.106-.234.234-.107,11.647-5.3,24.884-11.289.222-.1.1.222,8.539,18.883,3.6,7.991a22.679,22.679,0,0,1,1.448,3.663,12.044,12.044,0,0,1,.437,3.588,12.645,12.645,0,0,1-1.563,5.891,13.171,13.171,0,0,1-2.837,3.552,12.99,12.99,0,0,1-2.35,1.591l-.658.317A1.163,1.163,0,0,1,664.285,138.509Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M621.459,109.829c7.075,1.454,13.71,1.514,20.224-1.609s12.8-8.523,16.1-14.949Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M660.334,98.895a3.7,3.7,0,0,1,.624.664l1.66,2.005c1.485,1.855,3.511,4.385,5.983,7.47l4.1,5.184c.73.956,1.508,1.845,2.266,2.945a7.39,7.39,0,0,1,1.176,3.881,7.6,7.6,0,0,1-1.113,4.118,7.709,7.709,0,0,1-3.348,2.929l-8.174,3.768-4.15,1.907a20.392,20.392,0,0,1-4.206,1.617,12.78,12.78,0,0,1-11.707-3.274c-.922-.907-1.737-1.8-2.568-2.657l-4.558-4.786-6.557-6.971-1.753-1.924a3.7,3.7,0,0,1-.57-.711,3.738,3.738,0,0,1,.691.594l1.865,1.815,6.749,6.786,4.631,4.715c1.692,1.68,3.294,3.677,5.684,4.742a12.013,12.013,0,0,0,7.911.872,19.76,19.76,0,0,0,4.044-1.575l4.147-1.91,8.176-3.751a6.744,6.744,0,0,0,4.036-6.291,6.661,6.661,0,0,0-1.027-3.5c-.666-.993-1.492-1.974-2.192-2.913l-4.019-5.247-5.773-7.633-1.536-2.1A3.716,3.716,0,0,1,660.334,98.895Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M630.016,114.579a2.216,2.216,0,1,1-2.935-1.1A2.215,2.215,0,0,1,630.016,114.579Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M657.457,93.578c.581.773-.213,2.113.2,2.987a4.33,4.33,0,0,1-.838,4.912,1.348,1.348,0,0,0-.255.345,4.127,4.127,0,0,0,.092,3q.705,2.445,1.412,4.89a8.514,8.514,0,0,1,.492,3.1,2.9,2.9,0,0,1-1.658,2.5c-1.423.54-2.962-.565-3.793-1.839-1.042-1.6-1.544-3.586-3.391-4.54a2.272,2.272,0,0,0-2.636.277c-1.749,1.72,1.043,4.468-.59,6.137a2.011,2.011,0,0,1-1.789.518,5.259,5.259,0,0,1-3.019-2.313l-3.785-4.778,19.557-15.195",
    fill: "#ff725e"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess1);
export default __webpack_public_path__ + "static/media/process-1.b3333735dd22e76886c9891df79b0909.svg";
export { ForwardRef as ReactComponent };